export default __webpack_public_path__ + "5b732177c9d5947bd55e8c344ba8a655.ttf";